export const AlgoliaEnvironment = Object.freeze({
  DEV: 'dev',
  STG: 'stg',
  PROD: 'prod'
});
export const Source = Object.freeze({
  MPAC: 'MPAC',
  PRODUCT: 'PRODUCT'
});